<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'organizations.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <div class="row">
      <app-datatable [dataSource]="organizationSource"
                    [columns]=" columns"
                    [iconActions]="iconActions"
                    [identifier]="'partner-organizations'"
                    (newEvent)="new()"
                    (showEvent)="show($event.valueOf())">
        <app-empty-table [icon]="'groups'"
                        [emptyText]="'organizations.empty_text' | translate"
                        [buttonText]="'createNew' | translate"
        (btnClick)="new()">
        </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>

      <app-model-modal #EditModal (saveEvent)="onSave()">
        <app-partner-organization-form #form (closeEvent)="onModalClose()" (loadingEvent)="onLoading($event.valueOf())"></app-partner-organization-form>
      </app-model-modal>
    </div>
  </div>
</div>
